import { render, staticRenderFns } from "./competencies-list-panel.vue?vue&type=template&id=eb6e93b6&scoped=true&"
import script from "./competencies-list-panel.ts?vue&type=script&lang=ts&"
export * from "./competencies-list-panel.ts?vue&type=script&lang=ts&"
import style0 from "./competencies-list-panel.scss?vue&type=style&index=0&id=eb6e93b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6e93b6",
  null
  
)

export default component.exports